import { createPurchaseRequest } from '@/features/billing';
import type { AddFundsData, AddFundsResult, AddFundsCloseData } from './add-funds-panel';

export const addFundsRequest = createPurchaseRequest<AddFundsData, AddFundsResult, AddFundsCloseData>();
